export default "__VITE_ASSET__l0in0$7t__"